import { render, staticRenderFns } from "./AdvisoryPackageIntro.vue?vue&type=template&id=a3fef2e8&scoped=true"
import script from "./AdvisoryPackageIntro.vue?vue&type=script&lang=js"
export * from "./AdvisoryPackageIntro.vue?vue&type=script&lang=js"
import style0 from "./AdvisoryPackageIntro.vue?vue&type=style&index=0&id=a3fef2e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fef2e8",
  null
  
)

export default component.exports